import { IUseLoyaltyRewards, UseLoyaltyRewards } from 'state/loyalty/hooks/types';
import noop from 'utils/noop';

export const useLoyaltyRewards: UseLoyaltyRewards = () => {
  return {
    appliedLoyaltyRewards: {},
    availableLoyaltyRewardsMap: {},
    appliedLoyaltyRewardsArray: null,
    resetLoyaltyRewardState: noop
  } as IUseLoyaltyRewards;
};
